import React from "react";
import "../css/Header.css";
function Header() {
  return (
    <>
      <header className="header">
        <div className="container">
          <div className="nav-container">
            <div className="logo">
              <img src="images/Logo2.png" alt="Sess Link Logo" />
            </div>

            <nav className="nav">
              <ul className="nav-links">
                <li> <a href="/">Home</a> </li>
                <li className="dropdown">
                  Services <img src="./images/chevron-down.png" alt="" />
                  <ul className="dropdown-menu">
                    {/* <li>
                      <a href="#">Form Builder</a>
                    </li> */}
                    <li>
                      <a href="templatebuilder">Template Builder</a>
                    </li>
                    {/* <li>
                      <a href="#">Marketing Analytics</a>
                    </li>
                    <li>
                      <a href="#">Email Tracking</a>
                    </li> */}
                  </ul>
                </li>
                <li className="dropdown">
                  Products <img src="./images/chevron-down.png" alt="" />
                  <ul className="dropdown-menu">
                    {/* <li>
                      <a href="#">Invoice Generator</a>
                    </li> */}
                    <li>
                      <a href="/campaign">Campaign Management</a>
                    </li>
                    <li>
                      <a href="/referral">Referral Program</a>
                    </li>
                    <li>
                      <a href="/crm">CRM</a>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                  Solutions <img src="./images/chevron-down.png" alt="" />
                  <ul className="dropdown-menu">
                    {/* <li>
                      <a href="#">Email Marketing</a>
                    </li> */}
                    <li>
                      <a href="/campaign">Campaign</a>
                    </li>
                    <li>
                      <a href="/mailing">Mailing</a>
                    </li>
                    <li>
                      <a href="/erp">ERP</a>
                    </li>
                  </ul>
                </li>
                <li>   <a href="/pricing">Pricing</a></li>
              </ul>
              {/* <a href="https://app.sesslink.com/"  className="join-btn">
                Join Now
              </a> */}
                 <a href="/coming-soon"  className="join-btn">
                Join Now
              </a>
            </nav>

            <div className="hamburger">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
